/***
 格式化
 *@params money {Number or String} 金额
 *@params digit {Number} 小数点的位数，不够补0
 *@returns {String} 格式化后的金额
 **/

let formatMoney = function (money, digit=2) {
  let tpMoney = '0.00';
  if (undefined != money) {
    tpMoney = money;
  }
  tpMoney = new Number(tpMoney);
  if (isNaN(tpMoney)) {
    return '0.00';
  }
  tpMoney = tpMoney.toFixed(digit) + '';
  var re = /^(-?\d+)(\d{3})(\.?\d*)/;
  while (re.test(tpMoney)) {
    tpMoney = tpMoney.replace(re, "$1,$2$3")
  }

  return tpMoney;
}

export { formatMoney }



// WEBPACK FOOTER //
// ./src/filters/CommonFilters.js